<template>
  <div class="flex flex-col">
    <div class="flex items-center gap-2 px-4 pt-4 pb-3">
      <component :is="icon" class="size-4 shrink-0 text-gray-800" />
      <span class="text-[13px] font-medium leading-[20px] text-black">
        {{ title }}
      </span>
    </div>
    <div class="px-4 pb-3">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Component } from 'vue'

defineProps<{ title: string; icon: Component }>()
</script>
